import isNil from 'lodash/isNil';
import moment from 'moment';

moment.locale('ko');
export const defaultDateFormat = 'YYYY-MM-DD HH:mm';

export const defaultDateRangeOptions = {
  startPlaceholder: '시작',
  endPlaceholder: '종료',
  rangeSeparator: '~',
  format: 'MM-dd',
  defaultTime: ['00:00:00', '23:59:59'],
  pickerOptions: {
    shortcuts: [
      {
        text: '오늘',
        onClick(picker) {
          const start = moment()
            .startOf('day')
            .toDate();
          const end = moment()
            .endOf('day')
            .toDate();
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '이번 주',
        onClick(picker) {
          // TODO: 주의 시작과 끝 요일 기준 확인 후 기간 설정 버튼과 함께 수정 필요. 월-일, 일-토
          const start = moment()
            .startOf('isoWeek')
            .toDate();
          const end = moment()
            .endOf('isoWeek')
            .toDate();
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '이번 달',
        onClick(picker) {
          const start = moment()
            .startOf('month')
            .toDate();
          const end = moment()
            .endOf('month')
            .toDate();
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '올해',
        onClick(picker) {
          const start = moment()
            .startOf('year')
            .toDate();
          const end = moment()
            .endOf('year')
            .toDate();
          picker.$emit('pick', [start, end]);
        },
      },
    ],
  },
};

/**
 * 서버로 보낼 endDatetime(현재 datetime + 1초)를 만들어준다.
 * @param  {[type]} datetime [description]
 * @return {[type]}          [description]
 * @author jda
 */
export function getRequestDatetimeParams(datetime) {
  const date = new Date(datetime);
  return date.setSeconds(date.getSeconds() + 1);
}

/**
 * interval 및 intervalValue로 최근 datetime을 리턴해준다.
 * @param  {[type]} datetime      [description]
 * @param  {[type]} interval      [description]
 * @param  {[type]} intervalValue [description]
 * @return {[type]}               [description]
 * @author jda
 */
export function getIntervalDatetimeParams(datetime, interval, intervalValue) {
  const date = new Date(datetime);
  switch (interval) {
    case 'minute': {
      date.setMinutes(date.getMinutes() - intervalValue);
      break;
    }
    case 'hour': {
      date.setHours(date.getHours() - intervalValue);
      break;
    }
    case 'day': {
      date.setDate(date.getDate() - intervalValue);
      break;
    }
    case 'month': {
      date.setMonth(date.getMonth() - intervalValue);
      break;
    }
    case 'year': {
      date.setYear(date.getFullYear() - intervalValue);
      break;
    }
    default:
      break;
  }
  return date.getTime();
}

/**
 * 구동 시각으로부터 현재까지의 시간을 계산하여 리턴해준다.
 * @author jeee12
 * @param  {[type]} datetime [description]
 * @return {[type]}          [description]
 */
export function getUptimeFromNow(datetime) {
  if (isNil(datetime) || new Date(datetime).getTime() === new Date('1970-01-01 00:00:00').getTime()) {
    return '정보가 수집되지 않았습니다.';
  }
  const now = new Date();
  const uptime = new Date(datetime);
  const elapsedSec = parseInt(Math.abs(now.getTime() - uptime.getTime()) / 1000, 10);
  const nDays = elapsedSec / (60 * 60 * 24);
  const nHours = (nDays - Math.floor(nDays)) * 24;
  const nMinutes = (nHours - Math.floor(nHours)) * 60;
  const nSecond = (nMinutes - Math.floor(nMinutes)) * 60;

  let resultString = `${Math.floor(nSecond)} 초`;
  resultString = nMinutes > 0 ? `${Math.floor(nMinutes)}분 ${resultString}` : resultString;
  resultString = nHours > 0 ? `${Math.floor(nHours)}시간 ${resultString}` : resultString;
  resultString = nDays > 0 ? `${Math.floor(nDays)}일 ${resultString}` : resultString;

  return resultString;
}

/**
 * Date형식의 날짜를 String형식으로 변환한다.
 * @param  {[type]} datetime [description]
 * @param  {[type]} format   [description]
 * @return {[type]}          [description]
 * @author jda
 */
export function getDateToString(datetime, format) {
  let dateformat = format;
  if (isNil(format)) {
    dateformat = defaultDateFormat;
  }

  return moment(new Date(datetime)).format(dateformat);
}

/**
 * diffTime(miliseconds)을 받아와 경과시간을 출력한다.
 * @author Najongdang
 * @param  {[type]} diffTime [description]
 * @return {[type]}          [description]
 */
export function getDuration(diffTime) {
  if (diffTime < 1000) {
    return '0초';
  }
  let duration = '';
  const days = Math.floor(moment.duration(diffTime).asDays());
  const hours = moment.duration(diffTime).hours();
  const minutes = moment.duration(diffTime).minutes();
  const seconds = moment.duration(diffTime).seconds();
  if (days > 0) {
    duration = `${duration}${days}일 `;
  }
  if (hours > 0) {
    duration = `${duration}${hours}시간 `;
  }
  if (minutes > 0) {
    duration = `${duration}${minutes}분 `;
  }
  if (seconds > 0) {
    duration = `${duration}${seconds}초`;
  }
  return duration;
}

/**
 * 구동시간 계산
 * @author kimjy
 * @param  {Date} startTime 시작 시간
 * @param  {Date} endTime   끝 시간
 * @return {String}         구동시간
 */
export function calcUptime(startTime, endTime) {
  const duration = moment.duration(moment(endTime).diff(moment(startTime)));
  return getDuration(duration.asMilliseconds());
}

/**
 * 파라미터로 전달 받은 값을 Date 객체로 변환하여 반환한다.
 * Date형태가 될 수 없는 값일 경우 null을 반환한다.
 * @author Ju
 * @param  {[type]} date [description]
 * @return {[type]}      [description]
 */
export function getDate(value) {
  let date = null;
  if (moment.isDate(value)) {
    // Date
    date = value;
  } else if (typeof value === 'string' || typeof value === 'number') {
    const parsedDate = moment(value);
    if (parsedDate.isValid()) {
      date = parsedDate.toDate();
    }
  }

  return date;
}

/**
 * 날짜의 시간을 00:00:00으로 설정한다.
 * @author Ju
 * @param  {Date} datetime
 * @return {Date}
 */
export function removeTime(datetime) {
  return moment(datetime)
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0)
    .toDate();
}



// WEBPACK FOOTER //
// ./src/utils/date.js